import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { pageUp, pageDown, currentPage, set_ep1_lastVisitFrame } from '../../../Redux/Slices/generalSlice';
import { setLanguageEnglish, setLanguageUrdu, currentLanguage } from '../../../Redux/Slices/languageSlice';
import './F16.css';
import backIcon2 from '../../../Assests/backIcon2.svg'


function Frame16() {
    let [isLoading, setIsLoading] = useState(false);
    let dispatch = useDispatch();
    let pageNo = useSelector(currentPage);
    let language = useSelector(currentLanguage);
    useEffect(() => {
        setTimeout(function () { setIsLoading(false) }, 100);

    }, []);

    if (isLoading === true) {
        return (<div className="F15_image"></div>)
    } else {
        return (
            <div className="F16_imageAnimate">
                <img onClick={() => { dispatch(pageDown()) }} className='backButton' src={backIcon2} alt="React Logo" height={30} />
                <div className="F16_entryBox">
                    <div className="F16_paragraph">
                        {language === 'english' ?
                            <p className="F16_paragraphEnglish">Saira just heard a familiar knock on the door. This seems to be her elder sister Sofia who is very close to Saira. Saira is hesitant to open the door</p>
                            :
                            <p className="F16_paragraphUrdu">سائرا اچانک دروازے پر ایک جانی پہچانی دستک سنتی ہے۔ یہ ضرور سائرا کی بڑی بہن صوفیہ ہے جو کہ سائرا کے بہت قریب ہے۔ لیکن سائرا پھر بھی دروازہ کھولنے سے ہچکچا رہی ہے۔</p>
                        }
                    </div>

                    <div className="F16_timeline">
                        <div className='F16_timelineBar'>
                            <div className='F16_timelineFill'></div>
                            <span className='F16_timelineText'>12/16</span>
                        </div>
                    </div>

                    <div className="F16_nextFrames">
                        <div className="F16_nextFrame1"></div>
                        <div className="F16_nextFrame2"></div>
                        <div className="F16_nextFrame3"></div>
                    </div>

                    <div className='F16_buttonDiv'>
                        <button onClick={() => { dispatch(pageUp()); dispatch(set_ep1_lastVisitFrame(12)) }} className='F16_button'>
                            {language === 'english' ? 'Continue' : 'آگے  جائیں'}
                        </button>
                    </div>

                </div>
            </div>
        )
    }
}

export default Frame16;